import React from 'react';
import { shallowEqual } from 'react-redux';
import { Box } from '@apia/theme';
import { getVariant } from '@apia/theme';
import { Header } from '../Header';
import { useResponsiveTableContext } from '../ResponsiveTableContext';
import { Row } from '../Row';
import { NoRegistersRenderer } from './NoRegistersRenderer';
import { useDomProps } from '../store/selection/useDomProps';
import { useResponsiveTable } from '../store';

const NoMemoTableRenderer = ({ variant }: { variant?: string }) => {
  const { name, label, labels } = useResponsiveTableContext();
  const domProps = useDomProps(
    'table',
    {},
    (global) => global.responsiveTableSlice[name],
  );

  const rows = useResponsiveTable((global) => {
    const tableState = global.responsiveTableSlice[name];
    return tableState?.rows?.map((current) => current.id);
  }, shallowEqual);

  const columnsCount = useResponsiveTable(
    (global) =>
      (global.responsiveTableSlice[name]?.nonAdditionalColumnsCount ?? 0) +
      (global.responsiveTableSlice[name]?.hasNonAdditionalFilters ? 1 : 0) +
      (global.responsiveTableSlice[name]?.statesColumns?.length ?? 0) +
      (global.responsiveTableSlice[name]?.columns.find(
        (current) => current.showAsAdditional,
      )
        ? 1
        : 0),
  );

  const rowsCount = useResponsiveTable(
    (global) => global.responsiveTableSlice[name]?.rows.length || 0,
  );

  return (
    <Box
      {...domProps}
      as="table"
      className="responsiveTable__table"
      {...getVariant(variant || 'layout.common.tables.primary')}
      aria-label={label}
    >
      <Header />
      <tbody>
        {rowsCount > 0 ? (
          rows?.map((row, index) => {
            return (
              <Row key={row ?? `${row as string}-${index}`} rowIndex={index} />
            );
          })
        ) : labels.noRegisters ? (
          <tr>
            <td colSpan={columnsCount}>
              <NoRegistersRenderer />
            </td>
          </tr>
        ) : null}
      </tbody>
    </Box>
  );
};

export const TableRenderer = React.memo(NoMemoTableRenderer);
